// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__20nAC","alert":"SettungsInbox_alert__2NuN5"};